<template>
    <el-card
        class="ml-card"
        shadow="hover"
        @click.native="handleClick(info.id)"
    >
        <div class="image">
            <div
                :style="{ backgroundImage: 'url(' + info.imageUrl + ')' }"
            ></div>
        </div>
        <div>
            <p class="title">
                <span>{{ info.title }}</span>
            </p>
            <p class="info">
                <span>{{ info.leader }}</span>
                <span>
                    <i class="el-icon-user-solid" />
                    {{ info.count }}
                </span>
            </p>
        </div>
    </el-card>
</template>

<script>
import { Base64 } from "js-base64";

export default {
    components: {
        [Base64.name]: Base64
    },
    props: {
        info: {
            type: Object,
            default: () => {
                return {};
            }
        },
        edit: {
            type: Boolean,
            default: () => {
                return false;
            }
        }
    },
    methods: {
        handleClick() {
            if (!this.edit) {
                const id = encodeURI(Base64.encode(this.info.id));
                console.log(this.info);
                if(this.info.jump_url)
                {
                    window.open(this.info.jump_url)
                }
                else
                {
                     this.$router.push(`/declareExp/${id}`);
                }
                /*this.$router.push({
                    path: "/declareExp",
                    query: {
                        exp_id: id
                    }
                });//*/
            }
        }
    }
};
</script>

<style lang="scss">
.ml-card {
    cursor: pointer;

    .el-card__body {
        padding: 0;

        .image {
            height: 142px;
            width: 100%;

            div {
                height: 100%;
                width: 100%;
                background-size: cover;
                background-position: 50%;
            }
        }

        span {
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .title {
            margin: 0 5px;
            height: 30px;
            line-height: 30px;
            margin-bottom: 10px;
            color: #444;

            span {
                width: 100%;
            }
        }

        .info {
            height: 20px;
            line-height: 20px;
            margin: 0 5px;
            color: #999;

            span {
                margin-right: 10px;

                &:first-child {
                    max-width: 50%;
                }

                &:last-child {
                    max-width: 30%;
                    margin-right: 0px;
                    float: right;
                }
            }
        }
    }
}
</style>
